// import 'cross-fetch/polyfill'
import { useStoryblokApi } from '@storyblok/vue'

let cv = new Date().getTime()
export async function checkCacheVersion() {
  try {
    const { data } = await useStoryblokApi().get('cdn/spaces/me')
    cv = data.space.version
  } catch (e) {
    console.warn(`Error fetching Storyblok latest cache version`)
    cv = new Date().getTime()
  }
}

export const fetchStories = async (slugs, version) => {
  // This endpoint doesn't return folder root stories by default, so we need to add those slugs by hand
  const stories = [...slugs]
  slugs.forEach((slug) => {
    if (
      !['_theme', 'error-404', '_default'].some((toIgnore) =>
        slug.includes(toIgnore),
      )
    ) {
      stories.push(`${slug}/`)
    }
  })

  const { data } = await useStoryblokApi().get('cdn/stories', {
    version,
    resolve_relations: 'GlobalReference.reference',
    by_slugs: stories.join(','),
    cv: version === 'draft' ? new Date().getTime() : cv,
  })
  return data.stories.map((story) => {
    const content = story?.content
    const blocks = resolveGlobalReferences(content?.blocks)
    return { ...content, blocks, id: story?.id, slug: story?.full_slug }
  })
}

export function resolveGlobalReferences(blocks) {
  if (!blocks || !blocks.length) return []

  const result = []
  blocks.forEach((block) => {
    if (block.component === 'GlobalReference') {
      // We add the dynamic values defined for the global block to all its children
      let variables = {}
      const fields = block.variables?.split('\n') || []
      if (fields.length && fields[0]) {
        variables = fields.reduce((acc, nextField) => {
          const [name, value] = nextField.split('|')
          if (name) {
            acc[name.trim()] = value ? value.trim() : null
          }
          return acc
        }, {})
      }

      // Gets all blocks inside the GlobalReference and adds them to the block list
      const referencedBlocks = (block.reference.content?.blocks || []).map(
        (globalBlock) => ({
          ...globalBlock,
          isGlobal: true,
          reference: block._uid,
          variables,
        }),
      )
      result.push(...referencedBlocks)
    } else {
      result.push(block)
    }
  })

  return result
}

export async function getSiteProperties(siteSlug) {
  try {
    const { data } = await useStoryblokApi().get(`cdn/datasource_entries`, {
      datasource: siteSlug,
      per_page: 1000,
      cv,
    })

    return data?.datasource_entries?.reduce((acc, entry) => {
      acc[entry.name] = entry.value
      return acc
    }, {})
  } catch {
    return {}
  }
}
